import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '../views/layout/layout'

// modules





Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      component: Layout,
      name: 'index',
      redirect: '/index',
      hidden: true,
      children: [{
        path: 'index',
        component: () => import('@/views/pages/index')
      }]
    },
    /* 登录 */
    {
      path: '/login',
      component: () => import('@/views/pages/login/login'),
      name: 'login',
      meta: {
        title: '登陆',
        keepAlive: false
      }
    },

    /* 用户管理 */
    {
      path: '/',
      component: Layout,
      name: 'user',
      redirect: '/user',
      hidden: true,
      meta: {
        title: '用户管理'
      },
      children: [

        {
          path: '/user',
          component: () => import('@/views/pages/home/user'),
          name: 'user',
          meta: {
            title: '用户管理',
            keepAlive: false
          }
        },

        {
          path: '/changeDoctor',
          component: () => import('@/views/pages/home/changeDoctor'),
          name: 'changeDoctor',
          meta: {
            title: '成为医生',
            keepAlive: false
          }
        },
        {
          path: '/userDetail',
          component: () => import('@/views/pages/home/userDetail'),
          name: 'userDetail',
          meta: {
            title: '用户详情',
            keepAlive: false
          }
        },
        {
          path: '/userrecordlist',
          component: () => import('@/views/pages/home/userrecordlist'),
          name: 'user',
          meta: {
            title: '做题记录',
            keepAlive: false
          }
        },
        {
          path: '/userdatalist',
          component: () => import('@/views/pages/home/userdatalist'),
          name: 'user',
          meta: {
            title: '测评记录',
            keepAlive: false
          }
        },
        {
          path: '/userrecipeslist',
          component: () => import('@/views/pages/home/userrecipeslist'),
          name: 'user',
          meta: {
            title: '食谱信息',
            keepAlive: false
          }
        },
        {
          path: '/motion',
          component: () => import('@/views/pages/home/motion'),
          name: 'user',
          meta: {
            title: '运动步数',
            keepAlive: false
          }
        },
        {
          path: '/selfRecording',
          component: () => import('@/views/pages/home/selfRecording'),
          name: 'user',
          meta: {
            title: '自我记录',
            keepAlive: false
          }
        },
      ]
    },
    /* 医生管理 */
    {
      path: '/',
      component: Layout,
      name: 'user',
      redirect: '/user',
      hidden: true,
      meta: {
        title: '医生管理'
      },
      children: [
        {
          path: '/doctor',
          component: () => import('@/views/pages/home/doctor'),
          name: 'doctor',
          meta: {
            title: '医生管理',
            keepAlive: false
          }
        },
        {
          path: '/adddoctor',
          component: () => import('@/views/pages/home/adddoctor'),
          name: 'adddoctor',
          meta: {
            title: '编辑医生',
            keepAlive: false
          }
        },
        {
          path: '/contracted',
          component: () => import('@/views/pages/home/contracted'),
          name: 'contracted',
          meta: {
            title: '签约用户',
            keepAlive: false
          }
        },
      ]
    },
    /* 医院管理 */
    {
      path: '/',
      component: Layout,
      name: 'user',
      redirect: '/user',
      hidden: true,
      meta: {
        title: '医院管理'
      },
      children: [
        {
          path: '/hospital',
          component: () => import('@/views/pages/home/hospital'),
          name: 'hospital',
          meta: {
            title: '医院管理',
            keepAlive: false
          }
        },
      ]
    },
    /* 街道管理 */
    {
      path: '/',
      component: Layout,
      name: 'user',
      redirect: '/user',
      hidden: true,
      meta: {
        title: '街道管理'
      },
      children: [
        {
          path: '/street',
          component: () => import('@/views/pages/home/street'),
          name: 'street',
          meta: {
            title: '街道管理',
            keepAlive: false
          }
        },
      ]
    },
    /* 页面管理 */
    {
      path: '/',
      component: Layout,
      name: 'article',
      redirect: '/article',
      hidden: true,
      meta: {
        title: '广告管理'
      },
      children: [


        {
          path: '/banner',
          component: () => import('@/views/pages/home/banner'),
          name: 'banner',
          meta: {
            title: '轮播图',
            keepAlive: false
          }
        },
        {
          path: '/addBanner',
          component: () => import('@/views/pages/home/addBanner'),
          name: 'addBanner',
          meta: {
            title: '',
            keepAlive: false
          }
        },
      ]
    },
    /* 文章管理 */
    {
      path: '/',
      component: Layout,
      name: 'article',
      redirect: '/article',
      hidden: true,
      meta: {
        title: '文章管理'
      },
      children: [

        {
          path: '/article',
          component: () => import('@/views/pages/home/article'),
          name: 'article',
          meta: {
            title: '文章管理',
            keepAlive: false
          }
        },
        {
          path: '/addArticle',
          component: () => import('@/views/pages/home/addArticle'),
          name: 'addArticle',
          meta: {
            title: '',
            keepAlive: false
          }
        },
        {
          path: '/Popularscience',
          component: () => import('@/views/pages/home/Popularscience'),
          name: 'Popularscience',
          meta: {
            title: '科普文章',
            keepAlive: false
          }
        },
        {
          path: '/twoArticleClass',
          component: () => import('@/views/pages/home/twoArticleClass'),
          name: 'twoArticleClass',
          meta: {
            title: '二级分类列表',
            keepAlive: false
          }
        },
        {
          path: '/addtwoArticleClass',
          component: () => import('@/views/pages/home/addtwoArticleClass'),
          name: 'addtwoArticleClass',
          meta: {
            title: '编辑二级分类',
            keepAlive: false
          }
        },
        {
          path: '/activity',
          component: () => import('@/views/pages/home/activity'),
          name: 'activity',
          meta: {
            title: '活动管理',
            keepAlive: false
          }
        },
        {
          path: '/policy',
          component: () => import('@/views/pages/home/policy'),
          name: 'policy',
          meta: {
            title: '政策法规',
            keepAlive: false
          }
        },
        {
          path: '/latestInformation',
          component: () => import('@/views/pages/home/latestInformation'),
          name: 'policy',
          meta: {
            title: '最新信息',
            keepAlive: false
          }
        },
        {
          path: '/moneyStand',
          component: () => import('@/views/pages/home/moneyStand'),
          name: 'policy',
          meta: {
            title: '收费标准',
            keepAlive: false
          }
        },
      ]
    },
    /* 管理员管理 */
    {
      path: '/',
      component: Layout,
      name: 'useradmin',
      redirect: '/useradmin',
      hidden: true,
      meta: {
        title: '管理员管理'
      },
      children: [

        {
          path: '/useradmin',
          component: () => import('@/views/pages/home/useradmin'),
          name: 'useradmin',
          meta: {
            title: '活动管理',
            keepAlive: false
          }
        },
      ]
    },
    /* 版本号管理 */
    {
      path: '/',
      component: Layout,
      name: 'edition',
      redirect: '/edition',
      hidden: true,
      meta: {
        title: '版本管理'
      },
      children: [

        {
          path: '/edition',
          component: () => import('@/views/pages/home/edition'),
          name: 'edition',
          meta: {
            title: '活动管理',
            keepAlive: false
          }
        },
        {
          path: '/addedition',
          component: () => import('@/views/pages/home/addedition'),
          name: 'edition',
          meta: {
            title: '',
            keepAlive: false
          }
        },
      ]
    },
    /* 系统设置 */
    {
      path: '/',
      component: Layout,
      name: 'money',
      redirect: '/money',
      hidden: true,
      meta: {
        title: '系统设置'
      },
      children: [

        {
          path: '/money',
          component: () => import('@/views/pages/home/money'),
          name: 'money',
          meta: {
            title: '支付管理',
            keepAlive: false
          }
        },
        {
          path: '/setup',
          component: () => import('@/views/pages/home/setup'),
          name: 'setup',
          meta: {
            title: '客服管理',
            keepAlive: false
          }
        },
        {
          path: '/addsetup',
          component: () => import('@/views/pages/home/addsetup'),
          name: 'addsetup',
          meta: {
            title: '',
            keepAlive: false
          }
        },
        {
          path: '/health',
          component: () => import('@/views/pages/home/health'),
          name: 'health',
          meta: {
            title: '健康教育',
            keepAlive: false
          }
        },
        {
          path: '/moneyArtical',
          component: () => import('@/views/pages/home/moneyArtical'),
          name: 'moneyArtical',
          meta: {
            title: '支付协议',
            keepAlive: false
          }
        },
        {
          path: '/homeWords',
          component: () => import('@/views/pages/home/homeWords'),
          name: 'homeWords',
          meta: {
            title: '首页展示文字',
            keepAlive: false
          }
        },
        {
          path: '/addWords',
          component: () => import('@/views/pages/home/addWords'),
          name: 'addWords',
          meta: {
            title: '添加文字',
            keepAlive: false
          }
        },

      ]
    },
     /* 美奇设置 */
     {
      path: '/',
      component: Layout,
      name: 'meiqi',
      redirect: '/meiqi',
      hidden: true,
      meta: {
        title: '朵尔美&美奇'
      },
      children: [

        {
          path: '/couponManagement',
          component: () => import('@/views/pages/meiqi/couponManagement'),
          name: 'couponManagement',
          meta: {
            title: '优惠券管理',
            keepAlive: false
          }
        },
        {
          path: '/orderManagement',
          component: () => import('@/views/pages/meiqi/orderManagement'),
          name: 'orderManagement',
          meta: {
            title: '订单管理',
            keepAlive: false
          }
        },
        {
          path: '/financialManagement',
          component: () => import('@/views/pages/meiqi/financialManagement'),
          name: 'financialManagement',
          meta: {
            title: '财务管理',
            keepAlive: false
          }
        },
        {
          path: '/activityDetailsMaintenance',
          component: () => import('@/views/pages/meiqi/activityDetailsMaintenance'),
          name: 'activityDetailsMaintenance',
          meta: {
            title: '活动细则维护',
            keepAlive: false
          }
        },
        {
          path: '/updateActivity',
          component: () => import('@/views/pages/meiqi/updateActivity'),
          name: 'updateActivity',
          meta: {
            title: '活动细则维护',
            keepAlive: false
          }
        },
      ]
    },
    /* 活动设置 */
    {
      path: '/',
      component: Layout,
      name: 'huodong',
      redirect: '/huodong',
      hidden: true,
      meta: {
        title: ''
      },
      children: [

        {
          path: '/offlineActivityList',
          component: () => import('@/views/pages/huodong/offlineActivityList'),
          name: 'offlineActivityList',
          meta: {
            title: '线下活动列表',
            keepAlive: false
          }
        },
        {
          path: '/bookingManagement',
          component: () => import('@/views/pages/huodong/bookingManagement'),
          name: 'bookingManagement',
          meta: {
            title: '预约管理',
            keepAlive: false
          }
        },
        {
          path: '/listOfRegisteredUsers',
          component: () => import('@/views/pages/huodong/listOfRegisteredUsers'),
          name: 'listOfRegisteredUsers',
          meta: {
            title: '报名用户列表',
            keepAlive: false
          }
        },
        {
          path: '/onSiteVerification',
          component: () => import('@/views/pages/huodong/onSiteVerification'),
          name: 'onSiteVerification',
          meta: {
            title: '现场核销',
            keepAlive: false
          }
        },
        {
          path: '/timeSetting',
          component: () => import('@/views/pages/huodong/timeSetting'),
          name: 'timeSetting',
          meta: {
            title: '活动细则维护',
            keepAlive: false
          }
        },
      ]
    },
    /* 专家团队 */
    {
      path: '/',
      component: Layout,
      name: 'team',
      redirect: '/team',
      hidden: true,
      meta: {
        title: '专家团队'
      },
      children: [
        {
          path: '/team',
          component: () => import('@/views/pages/home/team'),
          name: 'team',
          meta: {
            title: "专家列表",
            keepAlive: false
          }
        },
        {
          path: '/addteam',
          component: () => import('@/views/pages/home/addteam'),
          name: 'addteam',
          meta: {
            title: '',
            keepAlive: false
          }
        },
      ]
    },
    
    


  ]
  
})



// WEBPACK FOOTER //
// ./src/router/index.js